<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Zonas de aparcamientos')"
      icono="mdi-select-marker"
      tabla="zon"
      :campos="['id_zon-', 'id_ins+', 'des+', 'pla']"
      :campos-filtrables="['id_ins']"
      busqueda-rapida
      :titulo-crud="$t ('zona de aparcamiento')"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("modconzon");
    }
  },
};
</script>

<style>
</style>